import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import RemoteService from '@avtechsoftware/ra-javascript-utilities/src/utilities/remoteService/remoteService';
import CrmQuote from '../../../../classes/CrmQuote';
import BasicQuoteInformation from '../../BasicQuoteInformation/BasicQuoteInformation';
import envConfig from '../../../../envConfig';
import checkIfUserIsSaml from '../../../../utility/checkIfUserIsSaml';
import { generateResourceURL } from '../../../../utility/orderAndQuoteUtil';
import { selectSessionInformation } from '../../../../redux/slices/sessionSlice';
import { sessionHash } from '../../../../utility/remoteServiceUtil';

function NoAccessQuoteScreen({
  quote, loadError, subscriptionId,
}) {
  const { activeSubscription } = useSelector(selectSessionInformation);
  const [isUserPending, setIsUserPending] = useState(false);
  const handleCheckIfPendingThisAccount = (pendingAssignArr) => pendingAssignArr
    .filter((assignment) => parseInt(assignment.subscriptionId, 10) === subscriptionId);
  const isSamlUser = checkIfUserIsSaml(activeSubscription);

  const fetchPendingAssignment = () => {
    RemoteService.get({
      url: `${envConfig.apiUrl}/api/v1/user/pending-assignments`,
      nonBearerAuthToken: sessionHash,
    })
      .then((response) => {
        const { pendingAssignments } = response;
        if (pendingAssignments && pendingAssignments.length > 0) {
          setIsUserPending(
            handleCheckIfPendingThisAccount(pendingAssignments).length > 0,
          );
        }
      });
  };

  const handleManageRequest = () => {
    window.location.href = '/user/subscriptions';
  };

  React.useEffect(() => {
    fetchPendingAssignment();
  }, []);

  /* istanbul ignore next */
  return (
    <div>
      <p>
        Basic information about your quote is listed below. For additional details
        <b> please request access.</b>
      </p>
      <div className="row">
        <div className="col-auto mb-2">
          <BasicQuoteInformation
            quoteNumber={quote.quoteNumber}
            quoteStatus={quote.statusType}
            createdAt={quote.createdAtDisplay}
            expiresAt={quote.expiresAtDisplay}
            loadError={loadError}
          />
        </div>
        <div className="col-lg-5 col-sm-12">
          {isUserPending
            ? (
              <div className="card bg-light" style={{ minHeight: '4rem' }}>
                <div className="card-body">
                  <div className="pb-3">
                    <p className="text-break">
                      You cannot view this quote&apos;s details because you don&apos;t currently
                      have access to the Room Alert Account associated with this quote.
                      A message has been sent to the owner of this account, asking them
                      to grant you access.
                    </p>
                    <button
                      type="button"
                      data-testid="manage-request"
                      className="btn btn-primary mt-3"
                      onClick={handleManageRequest}
                    >
                      Manage Request
                    </button>
                  </div>
                </div>
              </div>
            )
            : (
              <div className="card bg-light" style={{ minHeight: '4rem' }}>
                <div className="card-body">
                  <div className="pb-3">
                    <p>
                      You cannot view this quote&apos;s details because you don&apos;t currently
                      have access to the Room Alert Account associated with this quote.
                    </p>
                    {!isSamlUser && (
                    <a href={`${envConfig.raaUrl}/user/add-subscription?by=QUO-${quote.id}&referrer=/p/quote/${generateResourceURL(quote.id, quote.crmOrgId)}`}>
                      <button
                        type="button"
                        className="btn btn-primary mt-3"
                      >
                        Request Account Access
                      </button>
                    </a>
                    )}
                  </div>
                </div>
              </div>
            )}
        </div>
      </div>
    </div>
  );
}

NoAccessQuoteScreen.propTypes = {
  quote: PropTypes.shape(CrmQuote).isRequired,
  loadError: PropTypes.bool.isRequired,
  subscriptionId: PropTypes.number.isRequired,
};

export default NoAccessQuoteScreen;
